import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { WriteIcon } from 'Images';
import { goToRequestNewEquipment } from 'Utils';
import { NextPrevButton } from 'Components';

export const ThirdSegment = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);
  const isDesktop = useIsDesktop();

  return isDesktop ? (
    <Stack
      sx={{
        borderRadius: '16px',
        border: '1px solid',
        borderColor: 'purple2.shade_200',
        flexDirection: 'row',
        justifyContent: 'space-between',
        p: '24px',
        bgcolor: 'white',
      }}
    >
      <Stack flexDirection={'row'}>
        <Avatar
          src={WriteIcon}
          alt=''
          sx={{
            width: '48px',
            height: '48px',
            mr: '16px',
          }}
        />

        <Stack>
          <Typography component='h1' mb={isDesktop ? '4px' : '10px'}>
            {dictionary.youAlreadyHaveAMedicalRecommendationToReceiveEquipment}
          </Typography>
          <Typography component='h2' variant='body2'>
            {dictionary.ifYouReceivedRecommendationSubmitRequestForEquipment}
          </Typography>
        </Stack>
      </Stack>

      <NextPrevButton
        callback={goToRequestNewEquipment}
        style={{
          button: {
            p: '12px 16px 12px 24px',
            width: '325px',
            minWidth: '255px',
          },
        }}
        text={dictionary.submissionOfARequestForEligibilityForEquipment}
        isNext
        isBlue
      />
    </Stack>
  ) : (
    <Stack
      sx={{
        borderRadius: '16px',
        border: '1px solid',
        borderColor: 'purple2.shade_200',
        flexDirection: 'row',
        justifyContent: 'space-between',
        p: '16px',
        bgcolor: 'white',
      }}
    >
      <Stack flexDirection={'row'}>
        <Avatar
          src={WriteIcon}
          alt=''
          sx={{
            width: '38px',
            height: '38px',
            mr: '8px',
          }}
        />

        <Stack width={'100%'}>
          <Typography component='h1' mb={isDesktop ? '4px' : '10px'}>
            {dictionary.youAlreadyHaveAMedicalRecommendationToReceiveEquipment}
          </Typography>
          <Typography component='h2' variant='body2'>
            {dictionary.ifYouReceivedRecommendationSubmitRequestForEquipment}
          </Typography>
          <NextPrevButton
            callback={goToRequestNewEquipment}
            style={{
              button: {
                p: '10px 2px 10px 8px',
                width: '220px',
                fontSize: '14px',
                mt: 2,
              },
            }}
            text={dictionary.submissionOfARequestForEligibilityForEquipment}
            isNext
            isBlue
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
